<template>
  <div>
    <h3 class="title-group" v-text="titleGroup" />
    <table class="tui tuim ui selectable table">
      <thead>
        <tr>
          <th v-for="(head, i) in thead" :key="i" v-html="head.label" />
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td v-for="(item, k) in thead" :key="k">
            <t-placeholder :lines="2" />
          </td>
        </tr>
        <tr v-for="(items, i) in listDataGender" v-else :key="i" class="table-lines dashboard">
          <td v-for="(item, k) in items" :key="k"
            :class="
            k === 'id' ? 'hidden' : '' ||
            k === 'createdCount' ? 'hidden' : '' ||
            k === 'percentConvertedCreated' ? 'hidden' : '' ||
            k === 'convertedPaymentAmount' ? 'hidden' : '' ||
            k === 'convertedToPaymentPercent' ? 'hidden' : ''
            "
          >
            <span :id="k" :class="k === 'label' ? 'name' : '' || k === 'campaignGoal' ? 'meta' : ''" v-html="item" />

            <span v-if="k === 'convertedCount'" :id="k" class="records" > de {{items.createdCount}} <b>({{items.percentConvertedCreated}}%)</b></span>
            <span v-if="k === 'chargedAmount'" :id="k" class="finance" > de {{items.convertedPaymentAmount}} <b>({{items.convertedToPaymentPercent}}%)</b></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TTableDashborad',
  data() {
    return {
      thead: [
        { label: 'Grupo', name: 'grupo' },
        { label: 'Conversão de cadastros', name: 'records' },
        { label: 'Conversão de receita', name: 'finance' },
        { label: 'Meta', name: 'meta' },
        { label: 'Ticket médio', name: 'ticket' },
        { label: 'Valor recebido', name: 'value' }
      ],
      titleGroup: 'Por gênero'
    }
  },

  computed: {
    ...mapState({
      campaignId: ({ campaign }) => campaign.campaign.id,
      loading: ({ dashboard }) => dashboard.loading,
      listDataGender: ({ dashboard }) => dashboard.listDataGender
    })
  },

  mounted () {
    this.getCampaignByGenderQuery({campaignId: this.campaignId})
  },

  methods: {
    ...mapActions('dashboard', ['getCampaignByGenderQuery'])
  },
}
</script>

<style lang="scss" src="../table.scss"></style>
